/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {useQuery} from '@tanstack/react-query';

import {useService} from '@amblique/base/app/hooks/use-service';
import {ShopService} from '@amblique/base/shared/services/shop-service';

/**
 * @typedef {import('@salesforce/commerce-sdk-react').ApiQueryOptions} QueryOptions
 * @typedef {import('@tanstack/react-query').UseQueryResult<object, Error>} QueryResult
 *
 * @param {string|string[]} id
 * @param {QueryOptions}    queryOptions
 * @param {RequestInit}     requestOptions
 *
 * @returns {QueryResult}
 */
export function useContentAsset(id, queryOptions = {}, requestOptions = {}) {
  const shopService = useService(ShopService);

  return useQuery({
    ...queryOptions,
    enabled: shopService instanceof ShopService,
    queryKey: [shopService.key, 'content', Array.isArray(id) ? `[${id.join(',')}]` : id],
    queryFn: () => (
      Array.isArray(id) ?
        shopService.getContents(id, requestOptions).then(({data}) => data) :
        shopService.getContent(id, requestOptions)
    ),
  });
}
